import axios from './index';

class SavingPlanVariantApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `search=${data.searchTerm}&`;
    }
    if (data.planId) {
      query += `category=${data.planId}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.booleanFilter) {
      query += `is_active=${data.booleanFilter}&`;
    }
    if (data.selectedValues) {
      query += `category=${data.selectedValues}&`;
    }
    if (data.selectedPeriod) {
      query += `period=${data.selectedPeriod}&`;
    }

    return axios.get(`${base}/${query}`);
  };

  static Create = (data) => {
    console.log(data);
    let request = {
      // name: '',
      saving_plan_id: data.savingsPlanId,
      period: Number(data.period),
      min_investment: Number(data.minInvestment),
      max_investment: Number(data.maxInvestment),
      short_benefit: {
        text: data.benefit,
      },
      multiple_investment: Number(data.multipleInvestment),
      premature_withdrawal_allowed: data.prematureAllowed,
      making_charges_discount: Number(data.makingChargesDiscount),
      diamond_discount: Number(data.diamondDiscount),
      is_available: data.isAvailable,
      user_bank_required: data.userBankRequired || false,
      max_installment_allowed: Number(data.maxInstallmentAllowed) || 0,
      is_active: true,
      display_order: data.display_order || 1,
    };
    console.log('Data for Create', request);
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {};
    if (data.name) request.name = data.name;
    if (data.saving_plan_id) request.saving_plan_id = data.savingsPlanId;
    if (data.period) request.period = Number(data.period);
    if (data.minInvestment) request.min_investment = Number(data.minInvestment);
    if (data.maxInvestment) request.max_investment = Number(data.maxInvestment);
    if (data.makingChargesDiscount || data.makingChargesDiscount == 0) request.making_charges_discount = Number(data.makingChargesDiscount);
    if (data.diamondDiscount || data.diamondDiscount == 0) request.diamond_discount = Number(data.diamondDiscount);
    if (data.short_benefit) request.short_benefit = data.description;
    request.premature_withdrawal_allowed = data.prematureAllowed;
    request.is_available = data.isAvailable;
    request.user_bank_required = data.userBankRequired;
    if (data.is_active) request.is_active = data.is_active;
    if (data.display_order) request.display_order = data.display_order || 10;
    if (data.newDetail) request.details = data.newDetail;
    if (data.multipleInvestment)
      request.multiple_investment = Number(data.multipleInvestment);
    if(data.maxInstallmentAllowed)
      request.max_installment_allowed = Number(data.maxInstallmentAllowed);
    if (data.benefit) {
      request.short_benefit = {
        text: data.benefit,
      };
    }
    console.log('data :: ', data, request);
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };

  static getById = (id) => {
    return axios.get(`${base}/${id}`);
  };
}

let base = 'dashboard/saving-plan-variant';

export default SavingPlanVariantApi;
